// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useRef} from 'react';
import {t_page_meta} from '../../../../toolip/pub/types';
import {perr_www_visit} from 'hola_pub_util';
import {use_scrolled} from '../../../../hola/pub/ui_utils';
import {Hero} from '../../ui/homepage/hero';
import {Products} from '../../ui/homepage/products';
import {Why_oculus} from '../../ui/homepage/why_oculus';
import {Global} from '../../ui/homepage/global';
import {Scale_with_security} from '../../ui/homepage/security';
import {Use_cases} from '../../ui/homepage/use_cases';
import {Reviews} from '../../ui/homepage/reviews';
import {Proxies_compare} from '../../ui/homepage/proxies_compare';
import {HP_faq} from '../../ui/homepage/faq';
import styles from './index.module.less';

export const Root = ()=>{
    useEffect(()=>{ perr_www_visit({id: 'oculus_homepage_visit'}); }, []);
    const {y} = use_scrolled();
    const ref = useRef<HTMLDivElement>();
    useEffect(()=>{
        if (!ref.current)
            return;
        ref.current.style.setProperty('--y', `${y}px`);
    }, [y, ref.current]);
    return <div className={styles.root_ind} ref={ref}>
      <Hero/>
      <Products/>
      <Why_oculus/>
      <Proxies_compare/>
      <Use_cases/>
      <Reviews/>
      <Global/>
      <HP_faq/>
      <Scale_with_security/>
    </div>;
};

const meta: t_page_meta = {
    meta: {
        title: 'Premium Proxies Pocket friendly prices Try Now For Free '+
            '| Oculus',
        description: 'Discover premium proxies pocket friendly prices '+
            '- try now for free benefits.',
        canonical_url: 'https://oculusproxies.com'
    },
    no_ssr: false,
};

Root.meta = meta;
